import { useSyncExternalStore } from "react";
import { useNavigate } from "react-router-dom";
import { ChevronLeft, Gift } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { getSignupReferralCode } from "@/lib/signupReferralStorage";

function getHasCodeSnapshot(): boolean {
  return getSignupReferralCode().length >= 3;
}

/**
 * Card on signup that navigates to /signup/referral-code.
 * Re-renders when sessionStorage key changes (same-tab updates use custom event).
 */
export function ReferralInviteCard() {
  const navigate = useNavigate();

  const hasCode = useSyncExternalStore(
    (onStoreChange) => {
      const handler = () => onStoreChange();
      window.addEventListener("signup-referral-storage", handler);
      window.addEventListener("storage", handler);
      return () => {
        window.removeEventListener("signup-referral-storage", handler);
        window.removeEventListener("storage", handler);
      };
    },
    getHasCodeSnapshot,
    getHasCodeSnapshot
  );

  return (
    <button
      type="button"
      onClick={() => navigate("/signup/referral-code")}
      className="w-full text-right rounded-xl border border-primary/25 bg-gradient-to-br from-primary/8 via-primary/5 to-transparent px-3.5 py-3 min-h-[4.25rem] flex items-center gap-3 shadow-sm active:scale-[0.99] transition-transform hover:bg-primary/10 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/40 focus-visible:ring-offset-2"
    >
      <div className="w-10 h-10 rounded-full bg-primary/15 flex items-center justify-center shrink-0">
        <Gift className="w-[18px] h-[18px] text-primary" strokeWidth={2} aria-hidden />
      </div>
      <div className="flex-1 min-w-0">
        <div className="flex flex-wrap items-center gap-1.5 gap-y-0">
          <p className="text-sm font-bold text-foreground leading-tight">
            وصل لك كود من صديق؟
          </p>
          {hasCode ? (
            <Badge
              variant="secondary"
              className="text-[10px] px-1.5 py-0 h-5 bg-primary/15 text-primary border-0 font-semibold"
            >
              تم إدخال كود
            </Badge>
          ) : null}
        </div>
        <p className="text-xs text-muted-foreground mt-1 leading-snug">
          سجّل باستخدام الكود عشان يجيك الكاش باك 💰
        </p>
      </div>
      <ChevronLeft
        className="w-[18px] h-[18px] text-primary shrink-0 opacity-80"
        aria-hidden
      />
    </button>
  );
}
